import { AxiosError, AxiosResponse } from 'axios';
import  _ from 'lodash';

import { api, isRequestCanceled } from "../http";
import { DefaultCallback, DefaultRes } from "../types";
import { GeofenceTypes } from "../types/geofence.types";
import { RESPONSE_CODES } from '../constants/responseCodes.constants';
import { store } from '../store';

export class GeofenceService {
    public static readonly dispatch = store.dispatch.geofence;
    public static readonly state = store.getState();

    public static async createGeoPhone(
        params: GeofenceTypes.CreateGeoPhoneParams,
        callback: DefaultCallback,
    ) {
        try {
            this.dispatch.toggleLoading('createGeoPhone', true);

            const { 
                data: { 
                    result,
                    isValid,
                    message,
                },
            } = await api.post<
                DefaultRes<GeofenceTypes.GeofencePhoneNumber>,
                AxiosResponse<DefaultRes<GeofenceTypes.GeofencePhoneNumber>>
            >(`/geofences/createGeoPhone`, { ...params, phone: params.phone.toString() });

            this.dispatch.toggleLoading('createGeoPhone', false);

            if (isValid) {
                this.dispatch.addGeofencePhone(result);
            }

            callback(isValid, message);
        } catch (error: any) {
            this.dispatch.toggleLoading('createGeoPhone', false);
            
            if (error.response) {
                const ERROR_CODE = (
                    error as AxiosError<DefaultRes<GeofenceTypes.GeofencePhoneNumber>>
                ).response?.data?.message;

                callback && callback(false, RESPONSE_CODES[ERROR_CODE!]);
            }
            callback && callback(false, String(error));
        }
    }

    public static async updateGeoPhone(
        params: GeofenceTypes.UpdateGeoPhoneParams,
        callback: DefaultCallback,
    ) {
        try {
            this.dispatch.toggleLoading('updateGeoPhone', true);

            const { 
                data: { 
                    result,
                    isValid,
                    message,
                },
            } = await api.put<
                DefaultRes<GeofenceTypes.GeofencePhoneNumber>,
                AxiosResponse<DefaultRes<GeofenceTypes.GeofencePhoneNumber>>
            >(`/geofences/updateGeoPhone/${params.id}`, { ..._.omit(params, 'id'), phone: params.phone.toString() });

            this.dispatch.toggleLoading('updateGeoPhone', false);

            if (isValid) {
                this.dispatch.updateGeoPhone(result);
            }

            callback(isValid, message);
        } catch (error: any) {
            this.dispatch.toggleLoading('updateGeoPhone', false);
            
            if (error.response) {
                const ERROR_CODE = (
                    error as AxiosError<DefaultRes<GeofenceTypes.GeofencePhoneNumber>>
                ).response?.data?.message;

                callback && callback(false, RESPONSE_CODES[ERROR_CODE!]);
            }
            callback && callback(false, String(error));
        }
    }


    public static async createGeofence(
        params: GeofenceTypes.CreateGeofenceParams,
        callback: DefaultCallback
    ) {
        try {
            this.dispatch.toggleLoading('createGeofence', true);

            const { 
                data: { 
                    result,
                    isValid,
                    message,
                },
            } = await api.post<
                DefaultRes<GeofenceTypes.Model>,
                AxiosResponse<DefaultRes<GeofenceTypes.Model>>
            >(`/geofences/createGeofence`, { ...params, phoneNumberIds: [params.phoneNumberIds] });

            this.dispatch.toggleLoading('createGeofence', false);

            if (isValid) {
                this.dispatch.addGeofence(result);
            }

            callback(isValid, message)

        } catch (error: any) {
            this.dispatch.toggleLoading('createGeofence', false);
            if (error.response) {
                const ERROR_CODE = (
                    error as AxiosError<DefaultRes<GeofenceTypes.Model>>
                ).response?.data?.message;

                callback && callback(false, RESPONSE_CODES[ERROR_CODE!]);
            }

            callback && callback(false, String(error));
        }
    }

    public static async deleteGeoPhone(
        id: string,
        callback: DefaultCallback
    ) {
        try {
            this.dispatch.toggleLoading('deleteGeoPhone', true);

            const { 
                data: { 
                    result,
                    isValid,
                    message,
                },
            } = await api.delete<
                DefaultRes<boolean>,
                AxiosResponse<DefaultRes<boolean>>
            >(`/geofences/deleteGeoPhone/${id}`);

            if (isValid) {
                this.dispatch.deleteGeoPhone(id);
            }

            this.dispatch.toggleLoading('deleteGeoPhone', false);

            return callback(isValid, RESPONSE_CODES[message]);

        } catch (error: any) {
            this.dispatch.toggleLoading('deleteGeoPhone', false);
            if (error.response) {
                const ERROR_CODE = (
                    error as AxiosError<DefaultRes<GeofenceTypes.Model>>
                ).response?.data?.message;

                callback && callback(false, RESPONSE_CODES[ERROR_CODE!]);
            }

            callback && callback(false, String(error));
        }
    }

    public static async deleteGeofence(
        id: string,
        callback: DefaultCallback
    ) {
        try {
            this.dispatch.toggleLoading('deleteGeofence', true);

            const { 
                data: { 
                    result,
                    isValid,
                    message,
                },
            } = await api.delete<
                DefaultRes<boolean>,
                AxiosResponse<DefaultRes<boolean>>
            >(`/geofences/deleteGeofence/${id}`);

            if (isValid) {
                this.dispatch.deleteGeofence(id);
            }

            this.dispatch.toggleLoading('deleteGeofence', false);

            return callback(isValid, RESPONSE_CODES[message]);

        } catch (error: any) {
            this.dispatch.toggleLoading('deleteGeofence', false);
            if (error.response) {
                const ERROR_CODE = (
                    error as AxiosError<DefaultRes<GeofenceTypes.Model>>
                ).response?.data?.message;

                callback && callback(false, RESPONSE_CODES[ERROR_CODE!]);
            }

            callback && callback(false, String(error));
        }
    }

    public static async bulkGeofenceUpdate(
        params: GeofenceTypes.BulkGeofenceUpdateParams,
        callback: DefaultCallback
    ) {
        try {
            this.dispatch.toggleLoading('updateGeofence', true);

            const { 
                data: { 
                    result,
                    isValid,
                    message,
                },
            } = await api.put<
                DefaultRes<GeofenceTypes.Model[]>,
                AxiosResponse<DefaultRes<GeofenceTypes.Model[]>>
            >(`/geofences/bulkUpdateGeofences`, { geofences: params });

            this.dispatch.toggleLoading('updateGeofence', false);

            if (isValid) {
                this.dispatch.setGeofences(result);
            }

            return callback(isValid, RESPONSE_CODES[message]);
        } catch (error: any) {
            this.dispatch.toggleLoading('updateGeofence', false);
            if (error.response) {
                const ERROR_CODE = (
                    error as AxiosError<DefaultRes<GeofenceTypes.Model>>
                ).response?.data?.message;

                callback && callback(false, RESPONSE_CODES[ERROR_CODE!]);
            }

            callback && callback(false, String(error));
        }
    }

    public static async updateGeofence(
        params: GeofenceTypes.UpdateGeofenceParams,
        callback: DefaultCallback
    ) {
        try {
            this.dispatch.toggleLoading('updateGeofence', true);

            const { 
                data: { 
                    result,
                    isValid,
                    message,
                },
            } = await api.put<
                DefaultRes<GeofenceTypes.Model>,
                AxiosResponse<DefaultRes<GeofenceTypes.Model>>
            >(`/geofences/updateGeofence/${params.id}`, params);

            this.dispatch.toggleLoading('updateGeofence', false);

            if (isValid) {
                this.dispatch.updateGeofence(result);
            }

            return callback(isValid, RESPONSE_CODES[message]);

        } catch (error: any) {
            this.dispatch.toggleLoading('updateGeofence', false);
            if (error.response) {
                const ERROR_CODE = (
                    error as AxiosError<DefaultRes<GeofenceTypes.Model>>
                ).response?.data?.message;

                callback && callback(false, RESPONSE_CODES[ERROR_CODE!]);
            }

            callback && callback(false, String(error));
        }
    }

    public static async fetchGeofences(
        callback?: DefaultCallback,
        signal?: AbortSignal
    ) {

        this.dispatch.toggleLoading('fetchGeofences', true);

        try {
            const {
                data: {
                    result,
                    isValid,
                },
            } = await api.get<
                DefaultRes<GeofenceTypes.Model[]>,
                AxiosResponse<DefaultRes<GeofenceTypes.Model[]>>
            >(`/geofences/fetchGeofences`, { signal });

            if (isValid) {
                this.dispatch.setGeofences(result);
            }
        } catch (error: any) {
            if (isRequestCanceled(error)) {
                this.dispatch.toggleLoading('fetchGeofences', false);
                return;
            }
            this.dispatch.toggleLoading('fetchGeofences', false);
            if (error.response) {
                const ERROR_CODE = (
                    error as AxiosError<DefaultRes<GeofenceTypes.Model[]>>
                ).response?.data?.message;

                callback && callback(false, RESPONSE_CODES[ERROR_CODE!]);
            }

            callback && callback(false, String(error));
        }
    }

    public static async fetchGeoPhones(
        callback?: DefaultCallback,
        signal?: AbortSignal
    ) {

        this.dispatch.toggleLoading('fetchGeoPhones', true);

        try {
            const {
                data: {
                    result,
                    isValid,
                },
            } = await api.get<
                DefaultRes<GeofenceTypes.GeofencePhoneNumber[]>,
                AxiosResponse<DefaultRes<GeofenceTypes.GeofencePhoneNumber[]>>
            >(`/geofences/fetchGeoPhones`, { signal });

            if (isValid) {
                this.dispatch.setGeoPhones(result);
            }
        } catch (error: any) {
            if (isRequestCanceled(error)) {
                this.dispatch.toggleLoading('fetchGeoPhones', false);
                return;
            }
            this.dispatch.toggleLoading('fetchGeoPhones', false);
            if (error.response) {
                const ERROR_CODE = (
                    error as AxiosError<DefaultRes<GeofenceTypes.Model[]>>
                ).response?.data?.message;

                callback && callback(false, RESPONSE_CODES[ERROR_CODE!]);
            }

            callback && callback(false, String(error));
        }
    }
}
